import { Directive, Inject, OnInit, EventEmitter, OnDestroy, Injector } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';

import { IErrorHandler } from '../../../../shared/dataModels/contracts/IErrorHandler';
import { Configuration } from '../../../../shared/configurations/shared.config';
import { PointOfInterest,POIObjectView } from '../../../dataModels/poi';
import { MasterComponentService } from '../../../../shared/services/master-component.service';
import { MapService } from '../../../../shared/services/maps/map.service';
import { DiagnosedItem } from '../../../dataModels/diagnosed-item';

declare var $: any;

@Directive({
    selector: 'poi-view'
})
export class POIView extends DiagnosedItem implements OnInit, OnDestroy {

    private _errorHandler: IErrorHandler;
    private poiList: POIObjectView[] = [];
    private poiTypes: any[];

    private overlayHandlers: any[] = [];

    private zoomNumber: number;

    subscritption: EventEmitter<boolean>;

    constructor(private _mapService: MapService, private _http: Http, @Inject("IErrorHandler") handler: IErrorHandler, private _masterComponentService: MasterComponentService, protected injector: Injector) {
        super(injector);

        this._errorHandler = handler;

        //this.mapSettingsService.poiVisiblityChange.subscribe(obj => {

        //    this.setPoiVisiblity(obj.category.Id, obj.hidden);
        //});
        // subscribe to event zoom Changed
        //this._mapService.zoomChanged.subscribe(result => {
        //    this.zoomNumber = result;
        //    // hide it when zoom < 13
        //    this.hidePOI(this.zoomNumber < Configuration.mapSettings.objectsZoomThreshold);
        //});
    }

    ngOnInit() {
        this.subscritption = this._mapService.MapLoaded.subscribe((transporter: boolean) => {
            this.loadPOIs();
        });

    }

    loadPOIs() {
        let List = this._mapService.GetMapExtent();
        let minpoint = ol.proj.transform([List[0], List[1]], 'EPSG:3857', 'EPSG:4326');
        let maxpoint = ol.proj.transform([List[2], List[3]], 'EPSG:3857', 'EPSG:4326');
        let pointlist = [];
        pointlist.push(minpoint[0]);
        pointlist.push(minpoint[1]);
        pointlist.push(maxpoint[0]);
        pointlist.push(maxpoint[1]);
        this._http.post(Configuration.urls.webApiEndpoint + Configuration.urls.poiGetUrl, pointlist)
            .subscribe(response => {

                if (response && response.ok) {

                    var result = JSON.parse(response.text());

                    if (result && !result.IsErrorState) {

                        //Set Point List
                        this.poiList = result.Value;
                        this.drawPoints(this.poiList );
                        
                     }
                    else {
                        this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
                    }
                }
                else {
                    this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
                }

            }, error => {
                this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
            });
    }

    handleOverlays() {

        // if (this.poiList) {

        //     var categories: number[] = [];

        //     //find category list
        //     this.poiTypes.forEach(type => {

        //         var index: number = categories.findIndex(x => x == type.ExtraFields.CategoryId);

        //         if (index < 0) {
        //             categories.push(type.ExtraFields.CategoryId);
        //         }
        //     })

        //     //For each categoy
        //     for (var category of categories) {

        //         //Find all types of category
        //         var types = this.poiTypes.filter(type => type.ExtraFields.CategoryId == category);

        //         if (types && types.length > 0) {

        //             //Find all pois for types
        //             var filteredPoi: PointOfInterest[] = [];

        //             for (var type of types) {

        //                 //find POIs with the type
        //                 var items: PointOfInterest[] = this.poiList.filter(poi => poi.Type == type.Id);

        //                 if (items && items.length > 0) {

        //                     items.forEach(x => filteredPoi.push(x));
        //                 }
        //             }

        //             //if exist
        //             if (filteredPoi && filteredPoi.length > 0) {

        //                 //create new map Helper
        //                 /// var mapHelper: MapHelper = new MapHelper();

        //                 //Draw Points
        //               //  this.drawPoints(filteredPoi);


        //             }
        //         }
        //     }
        // }
    }

    drawPoints(list: POIObjectView[]) {

        if (list && list.length > 0) {

            var markers: any[] = [];

            //  mapHelper.setMap(this._mapService.getMap());

            list.forEach((point, index) => {

                var iElement = document.createElement("span");
                iElement.className =point.ViewName;
                iElement.setAttribute("aria-hidden", "true");
                var anchorElement = document.createElement("a");
                anchorElement.id = "map-pin";
                anchorElement.className = "poi-pin";

                if (iElement.className.indexOf("stop") > 0) {
                    anchorElement.style.borderRadius = "5px";
                    anchorElement.style.padding = "2.4px 4.5px 2.3px 3px";
                }



                anchorElement.appendChild(iElement);

                var mainDiv = document.createElement("div");
                mainDiv.className = "car-container poi-icon-shape";

                mainDiv.appendChild(anchorElement);
                var xthis = this;
                $(mainDiv).click(function (event) {
                    var poiId = this.id.split('-')[1];
                  
                   
                    xthis.DisplayPOIDetails(poiId)
                });
                mainDiv.id = "POI-" + point.Id;
                document.body.appendChild(mainDiv);
                this._mapService.addOverlay(point.Location.Longitude, point.Location.Latitude, mainDiv.id.toString());
            });

            
        }
    }
    DisplayPOIDetails(poiId)
    {  var xthis= this;
        this._http.get(Configuration.urls.webApiEndpoint + Configuration.urls.poiUrl+poiId)
        .subscribe(response => {

            if (response && response.ok) {

                var result = JSON.parse(response.text());

                if (result && !result.IsErrorState) {

                    //Set Point List
                    var poi = result.Value;
                    
                    xthis._masterComponentService.rightBarComponentName = "POIDetails";

                    xthis._masterComponentService.detailsChanged.emit(poi);
            
                    xthis._masterComponentService.toggleRigthBar();
                 }
                else {
                    this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
                }
            }
            else {
                this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
            }

        }, error => {
            this._errorHandler.Handle(Configuration.messages.defaultErrorMessage);
        });
      
    }
    setPoiVisiblity(categoryId: number, hidden: boolean) {

        //Ignore the visiblity at invalid Zoom level
        //if (!hidden && this._mapService.getZoomLevel() < Configuration.mapSettings.objectsZoomThreshold) {
        //    return;
        //}

        //if (this.overlayHandlers && this.overlayHandlers.length > 0) {

        //    var index = this.overlayHandlers.findIndex(x => x.category == categoryId);

        //    if (index >= 0) {

        //        this.overlayHandlers[index].helper.overlayObjects.forEach(obj => {

        //            obj.element.hidden = hidden;
        //        });
        //    }
        //}
    }

    hidePOI(hidden: boolean) {

        //if (this.overlayHandlers && this.overlayHandlers.length > 0) {

        //    var allowed: boolean = true;

        //    this.overlayHandlers.forEach(obj => {

        //        if (!hidden) {

        //           // allowed = this.mapSettingsService.allowToShow(obj.category);
        //        }
        //        else {
        //            allowed = true;
        //        }

        //        if (allowed) {

        //            obj.helper.overlayObjects.forEach(o => {
        //                o.element.hidden = hidden;
        //            })
        //        }
        //    });
        //}
    }

    ngOnDestroy() {
        this.subscritption && this.subscritption.unsubscribe();
    }
}


// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/poi/poiView/poi-view.directive.ts